import Dialoguemodal from 'components/dialoguemodal'
import CreateCardholder from 'layouts/admin/cardholder/create-cardholder'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'

// import { FormattedMessage, useIntl } from 'react-intl'

function Edit({ user, updateList, idx }) {
  const { formatMessage, locale } = useIntl()
  const [open, setOpen] = useState(false)

  const handleFormClose = (updates) => {
    setOpen(false)
    updateList(updates, idx)
  }
  return (
    <>
      <span
        onClick={() => setOpen(true)}
        class='tw-text-medium tw-text-navyBlue tw-invisible group-hover:tw-visible hover:tw-cursor-pointer tw-undefined'
      >
        {formatMessage({ id: 'Edit' })}
      </span>
      <Dialoguemodal open={open} onClose={() => setOpen(false)}>
        <CreateCardholder user={user} onClose={handleFormClose} />
      </Dialoguemodal>
    </>
  )
}

export default Edit
